<div class="header mt-3 mb-3" [class.add]="allowAdd">
  <div>
    <span class="title">DOCUMENT REPOSITORY</span>
    <span class="doc-count ml-2" *ngIf="!allowAdd && !!documents">({{documents.length + (documents.length > 1 ? " RESULTS" : " RESULT")}})</span>
  </div>
  <button type="button" class="btn border-0" (click)="showModal()" *ngIf="allowAdd">
    <span><i class="icon icon-btn-add-doc" aria-hidden="true"></i></span>
  </button>
</div>

<div class="filter-order">
  <app-search-expand [(isExpanded)]="isExpanded" [subSearch]="true" [setSearchText]="search" (searching)="onSearch($event)"></app-search-expand>
  <app-dropdown-sort [label]="''" (select)="onSorting($event)"></app-dropdown-sort>
</div>

<div class="file-container sticky-top" cdkDropList>
  <div class="file-row" *ngFor="let document of documents" cdkDrag [cdkDragData]="document">
    <app-document-item
      cdkDragHandle
      [file]="document"
      (deleted)="onDocumentDeleted($event)">
    </app-document-item>
  </div>
</div>

<button type="button" *ngIf="!!lastEvaluatedKey" class="btn btn-link link-arrow more-results float-right text-right text-uppercase pr-0 mr-0" (click)="getNext()">
  More results<i class="icon icon-arrow-fwd-sm-link"></i>
</button>
